module.exports = __webpack_public_path__ + "static/media/Step 1-Enter_Project_Info.8b527cc8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/media/tutorial-images/Step 1-Enter_Project_Info.gif
// module id = 3042
// module chunks = 0